export default __webpack_public_path__ + "static/media/search_icon_white.faabbb88.svg";